/* eslint-disable no-unused-vars */
export enum EProofOfDeliveryType {
    NONE = 'NONE',
    PHOTO = 'PHOTO',
    CODE = 'CODE',
}
